import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLoggedInUser, useAuth } from "../../auth/authUtil";

const ProtectedRoutes = () => {
    let isAuth = useAuth();
    let currentUser = getLoggedInUser();
    if (isAuth && currentUser && currentUser?.authorities)
        return <Outlet />
    else
        return <Navigate to="/login" />

    //return <Outlet/>
}

export default ProtectedRoutes


